<template>
  <div class="animated fadeIn">
    <vue-headful :title="`Lista Leadów`" />
    <b-row>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Filtry</strong>
          </div>
          <div>
            <b-form inline class="filter-form">
              <b-input :class="(filters.formName) ? `filled-filter` : ``" id="title" type="text" placeholder="Nazwa formularza" v-model="filters.formName"></b-input>
              <label class="mx-sm-2" for="project">Projekt: </label>
              <b-form-select :class="(filters.projectId !== -1) ? `filled-filter` : ``" id="project" :plain="true"
                             :options="projectsOptions" v-model="filters.projectId">
              </b-form-select>
              <label class="mx-sm-2"></label>
              <b-button variant="primary" @click="filters = defaultFilter()"><i class="fa fa-times"></i> Wyczyść</b-button>
            </b-form>
          </div>
        </b-card>
        <b-card header-tag="header" footer-tag="footer">
          <div slot="header">
            <i class="fa fa-align-justify"></i> <strong>Leady</strong>
          </div>
          <b-col md="12" v-if="loading">
            <div class="loading" >Loading...</div>
          </b-col>
          <div v-else-if="leads.data && leads.data.length > 0" class="scrollable-list">
            <b-list-group v-bind:key="lead.id" v-bind:item="lead" v-for="lead in leads.data">
              <b-list-group-item :variant="(currentLead && lead.id === currentLead.id) ? `primary` : ``" class="flex-column align-items-start cursor-pointer" @click="currentLead = lead;">
                <div class="m-1 d-flex w-100 justify-content-between">
                  <h5 class="cursor-pointer mb-1">{{ lead.createdAt }}</h5>
                  <span>
                    <i class="fa fa-external-link cursor-pointer" title="Podgląd" v-on:click="overview(lead.id)"></i>
                  </span>
                </div>
                <p class="mb-1">
                    <span v-if="lead.meta['form-url']">{{ lead.meta['form-url'] }}</span>
                </p>
                <b-badge class="badge-blue"> {{ lead.projectName }} </b-badge>
                <b-badge class="badge-success"> {{ lead.formName }} </b-badge>
              </b-list-group-item>
            </b-list-group>
          </div>
          <div v-else><i>Brak leadów</i></div>
          <div class="show-more-box" v-if="leads.showMore">
            <button class="btn btn-outline-primary float-right" href="#" v-on:click="paginateLeads()">więcej</button>
          </div>
        </b-card>
      </b-col>
      <b-col md="6" v-if="currentLead">
        <b-card header-tag="header" footer-tag="footer">
          <div slot="header">
            <i class="fa fa-align-justify"></i> <strong>Podgląd</strong>
          </div>
          <c-lead-overview :lead="currentLead"></c-lead-overview>
          <div slot="footer">
            <b-button class="float-right" variant="danger" @click="remove(currentLead)">Usuń</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import leadsClient from '../../service/leadsClient'
import vueHeadful from 'vue-headful'
import CLeadOverview from '../../components/Lead/LeadOverview'
import paginator from '../../components/paginator'
import storage from '../../components/storage'
import projectHelper from '../../components/Project/projectHelper'
import config from '../../config'

const LIMIT = 25

export default {
  name: 'leads-list',
  components: {
    vueHeadful,
    CLeadOverview
  },
  data () {
    return {
      currentLead: null,
      loading: false,
      leads: paginator.method.defaultObject(),
      projectsOptions: [],
      filters: this.defaultFilter(),
      awaitingFilters: false,
      limit: '15',
      offset: '0'
    }
  },
  created () {
    this.refreshLeads()
    this.filters = this.loadFiltersFromStorage()
  },
  mounted () {
    this.getProjects()
  },
  watch: {
    filters: {
      deep: true,
      async handler (filters) {
        const savedFilters = this.loadFiltersFromStorage()
        const nameChanged = savedFilters.formName !== filters.formName
        this.saveFiltersToStorage()
        if (nameChanged) {
          await this.postponeRefreshLeads()
        } else {
          await this.refreshLeads()
        }
      }
    }
  },
  methods: {
    async paginateLeads () {
      this.loading = true
      try {
        const leads = await leadsClient.getLeads((LIMIT + 1), this.leads.offset, this.filters)
        paginator.method.pagination(this, 'leads', leads)
      } finally {
        this.loading = false
      }
    },
    async refreshLeads () {
      this.loading = true
      try {
        const data = await leadsClient.getLeads((LIMIT + 1), 0, this.filters)
        this.leads = paginator.method.defaultObject()
        this.leads.limit = LIMIT
        paginator.method.pagination(this, 'leads', data)
      } finally {
        this.loading = false
      }
    },
    async postponeRefreshLeads () {
      if (!this.awaitingFilters) {
        setTimeout(() => {
          this.refreshLeads()
          this.awaitingFilters = false
        }, 300)
      }
      this.awaitingFilters = true
    },
    async remove (lead) {
      await this.$confirm('Czy na pewno usunąć leada z ' + lead.createdAt + '?', lead.formName, '', { confirmButtonText: 'Tak', cancelButtonText: 'Nie' })
      await leadsClient.removeLead(lead.id)
      if (lead === this.currentLead) {
        this.currentLead = null
      }
      await this.refreshLeads()
    },
    async overview (id) {
      window.open(config.services.publicLeads.url + '/formularz/' + id, '_blank')
    },
    saveFiltersToStorage () {
      storage.set('leadsFilters', this.filters)
    },
    loadFiltersFromStorage () {
      return storage.get('leadsFilters', this.defaultFilter())
    },
    defaultFilter () {
      return {
        formName: '',
        projectId: -1
      }
    },
    async getProjects () {
      const projects = await leadsClient.getProjects(999, 0)
      this.projectsOptions = projectHelper.getProjectOptions(projects)
    }
  }
}
</script>
